/* 
	* Validation error messages for paid works page
*/

export const PRISONWORKS_VALIDATION_CONTEXT = {

	required: {
		section: 'Section cannot be blank',
		jobLocation: `Job location cannot be blank`,
		jobTitle: `Job title cannot be blank`,
		jobStartDate: 'Start date cannot be blank',
		otherSkillDescription: `Enter other skills description, it cannot be blank`,
		otherSectionName: `Enter other section, it cannot be blank`,

	},
	invalidDate: {
		jobStartDate: 'Enter a valid start date',
		jobEndDate: 'Enter a valid end date',
	},
	futureDate: {
		jobStartDate: 'Start date cannot be in the future',
		jobEndDate: 'End date cannot be in the future'
	},
	maxSelected: {
		answers: 'Select 3 skills from the available',
	},
	minSelected: {
		answers: 'Select 3 skills from the available',
	},
	invalidEndDateOrCurrent: {
		jobEndDate: 'Start date must be accompanied by either an end date or current employment selection',
	},
	afterEndDate: {
		jobEndDate: 'Start date cannot be after end date',
	},
	invalidEndDateAndCurrent: {
		jobEndDate: 'Start date cannot be accompanied by both end date and current employment selection',
	},
	maxlength: {
		jobTitle: 'Please enter 100 or less characters in job title',
		otherSectionName: 'Please enter 200 or less characters in other section description',
		otherSkillDescription: 'Please enter 200 or less characters in other skills description',
	},
	invalidPastYear: {
		jobStartDate: 'Job start year cannot be more than 80 years in the past',
	},
	pattern: {
		otherSkillDescription: 'Other skills description contains disallowed characters'
	}
}